module.exports = __webpack_public_path__ + "img/new14-4.ccd826ae.jpg";